import * as Sentry from '@sentry/react'

if (import.meta.env.PROD) {
	Sentry.init({
		dsn: 'https://de9e25ef37e74f5b95240d1af8834e89@o360459.ingest.sentry.io/6591018',
		environment: import.meta.env.VITE_STAGE,
		release: import.meta.env.SENTRY_RELEASE,
		ignoreErrors: [
			'ResizeObserver loop limit exceeded',
			/ResizeObserver loop/,
			'{"code":43,"StatusCode":401,"message":"WS failed with code 43 and reason - JWTAuth error',
		],
	})
}
